export default function AboutUsRoute() {
	return (
		<main>
			<div className="relative isolate overflow-hidden bg-stone-900">
				<div className="absolute inset-x-0 top-1/2 -z-10 -translate-y-1/2 transform-gpu overflow-hidden opacity-30 blur-3xl">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[max(50%,38rem)] w-[82.0625rem]"
					>
						<path
							id="bc169a03-3518-42d4-ab1e-d3eadac65edc"
							fill="url(#85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3)"
							d="M360.508 589.796 231.671 770.522 0 498.159l360.508 91.637 232.034-325.485c1.485 150.396 51.235 393.965 238.354 165.069C1064.79 143.261 1002.42-107.094 1171.72 46.97c135.44 123.252 148.51 335.641 138.11 426.428L971.677 339.803l24.062 411.461-635.231-161.468Z"
						/>
						<defs>
							<linearGradient
								id="85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3"
								x1="1313.17"
								x2="-88.881"
								y1=".201"
								y2="539.417"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#9089FC" />
								<stop offset={1} stopColor="#FF80B5" />
							</linearGradient>
						</defs>
					</svg>
				</div>
				<div className="absolute inset-x-0 top-0 -z-10 flex transform-gpu overflow-hidden pt-32 opacity-25 blur-3xl sm:pt-40 xl:justify-end">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[-22rem] w-[82.0625rem] flex-none origin-top-right rotate-[30deg] xl:ml-0 xl:mr-[calc(50%-12rem)]"
					>
						<use href="#bc169a03-3518-42d4-ab1e-d3eadac65edc" />
					</svg>
				</div>
				<div className="mx-4 mt-32 rounded-2xl bg-[#f9c04d] p-2 ring-1 ring-inset ring-[#f9c04d] sm:mx-12 sm:mt-40 xl:mx-auto xl:max-w-7xl xl:rounded-3xl">
					<img
						src="/images/about.jpg"
						alt=""
						className="aspect-[9/4] w-full rounded-md object-cover shadow-2xl ring-1 xl:rounded-3xl"
					/>
				</div>
				<div className="px-6 pt-14 sm:px-8">
					<div className="mx-auto max-w-2xl text-center sm:pt-12">
						<h2 className="text-4xl font-bold tracking-tight text-white sm:text-6xl">
							We love what we do!
						</h2>
						<p className="mt-6 text-lg leading-8 text-gray-300">
							Our goal is to provide the highest quality dance education by
							sustaining a nurturing and positive atmosphere wherein young
							students may grow and learn.
						</p>
					</div>
				</div>
				<div className="mx-auto mt-20 max-w-7xl px-6 lg:px-8">
					<div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-none">
						<div className="grid max-w-xl grid-cols-1 gap-8 text-base leading-7 text-gray-300 lg:max-w-none lg:grid-cols-2">
							<div>
								<p>
									<span className="text-[#f9c04d]">
										Stage Door Dance Academy
									</span>{' '}
									opened its doors in 1992 in Palos Park, Illinois. The entrance
									was in the back of the building emulating a theater’s “stage
									door” and that’s how we took the name “Stage Door Dance
									Academy.” In 2005, we relocated to our present location in Oak
									Forest. We look forward to celebrating our{' '}
									<span className="text-[#f9c04d]">35th season</span> of dance
									with you!
								</p>
							</div>
							<div>
								<p>
									Our studio is a space for inspiring the next generation. We
									work to make each dancer feel a part of our Stage Door family
									and our goal is to make a positive impact on all who share in
									our dance community.
								</p>
							</div>
							<div>
								<p>
									We strive to provide a safe and fun environment for all of our
									dancers. We are proud to offer a variety of classes for all
									ages and levels of dancers. We offer classes in Ballet, Tap,
									Jazz, Hip Hop, Lyrical, Contemporary, Pointe, and Musical
									Theater. We have classes for dancers ages 18 months through
									adult. We offer both recreational and competitive classes.
								</p>
							</div>
							<div>
								<p>
									We are located in Oak Forest, IL and our dance families are
									from numerous surrounding suburbs including Orland Park,
									Tinley Park, Palos Park, Palos Heights, Midlothian, Crestwood,
									Alsip, Frankfort, Homer Glen, Oak Lawn, Mokena, Homewood, Blue
									Island, New Lenox, Lemont, Lockport, Orland Hills, Palos
									Hills, and more!
								</p>
							</div>
						</div>
						<dl className="my-32 grid grid-cols-1 gap-x-8 gap-y-16 text-center lg:grid-cols-3">
							{stats.map((stat) => (
								<div
									key={stat.id}
									className="mx-auto flex max-w-xs flex-col gap-y-4"
								>
									<dt className="text-base leading-7 text-stone-50">
										{stat.name}
									</dt>
									<dd className="order-first text-3xl font-semibold tracking-tight text-stone-50 sm:text-5xl">
										{stat.value}
									</dd>
								</div>
							))}
						</dl>
					</div>
				</div>
			</div>
		</main>
	)
}

const stats = [
	{ id: 1, name: 'Opened our doors in Palos Park, IL', value: '1992' },
	{
		id: 2,
		name: 'Relocated to our present location in Oak Forest, IL',
		value: '2005',
	},
	{
		id: 3,
		name: 'Honored to celebrate so many years of dance with you',
		value: '35th Season',
	},
]
